import React from "react";
import usePosOrder from "@/context/pos/UsePosOrder";
import LoadingState from "@widgets/pos/orders/details/section/LoadingState";
import EmptyState from "@widgets/pos/orders/details/section/EmptyState";
import Order from "@widgets/pos/orders/details/order/Order";

type Props = {
    selectedPublicCartId: string | undefined,
};

const OrderOverview = ({selectedPublicCartId}: Props) => {
    const {data: order, isFetching} = usePosOrder(selectedPublicCartId);

    if (selectedPublicCartId === undefined) {
        return <EmptyState/>;
    }

    if (isFetching || order === undefined) {
        return <LoadingState/>;
    }

    return (
        <Order
            key={selectedPublicCartId}
            order={order}
        />
    );
};

export default OrderOverview;